<template>
    <section class="guide-abstract-slice">
        <PrismicRichText :field="slice.primary.title" class="title" />
        <div class="abstracts">
            <div v-for="item in slice.items" :key="`slice-abstract-item-${item}`" class="abstract">
                <div class="abstract-preview">
                    <PrismicRichText :field="item.headline" class="abstract-headline" />
                    <PrismicRichText :field="item.title" class="abstract-title" />
                </div>
                <PrismicRichText :field="item.content" class="abstract-content" />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {GuideAbstractSlice} from '@prismicio-types';

    defineProps(getSliceComponentProps<GuideAbstractSlice>());
</script>

<style lang="scss">
    @use '~/assets/styles/variables' as *;

    .guide-abstract-slice {
        @include content-width($article-max-width);

        .title {
            margin-bottom: var(--joy-core-spacing-7);
        }
        .abstracts {
            display: flex;
            flex-direction: column;
            gap: var(--joy-core-spacing-4);

            .abstract {
                background-color: var(--joy-color-quaternary-10);
                padding: var(--joy-core-spacing-6);
                border-radius: var(--joy-core-radius-3);

                .malt-strategy-theme & {
                    background-color: var(--joy-color-neutral-20);
                }

                .abstract-preview {
                    animation: fadeIn var(--joy-transition-duration-long);
                    display: block;
                    @media (max-width: $tablet-breakpoint) {
                        animation: none;
                    }
                }
                .abstract-headline {
                    margin-bottom: var(--joy-core-spacing-2);
                    * {
                        color: var(--joy-color-neutral-40);
                    }
                }
                .abstract-title * {
                    font-size: var(--joy-font-size-secondary-200);
                    @media (max-width: $mobile-breakpoint) {
                        font-size: var(--joy-font-size-primary-600);
                    }
                }
                .abstract-content {
                    animation: fadeOut var(--joy-transition-duration-long);
                    display: none;

                    * {
                        color: var(--joy-color-neutral-40);
                    }
                    @media (max-width: $tablet-breakpoint) {
                        margin-top: var(--joy-core-spacing-2);
                        display: block;
                        animation: none;
                    }
                }

                &:hover {
                    .abstract-preview {
                        display: none;
                        animation: fadeOut var(--joy-transition-duration-long);
                        @media (max-width: $tablet-breakpoint) {
                            display: block;
                            animation: none;
                        }
                    }
                    .abstract-content {
                        display: block;
                        animation: fadeIn var(--joy-transition-duration-long);
                        @media (max-width: $tablet-breakpoint) {
                            animation: none;
                        }
                    }
                }
            }
        }

        /* TODO : clean up if already exists in joy */
        @keyframes fadeIn {
            0% {
                opacity: 0;
            }
            100% {
                opacity: 1;
            }
        }
        @keyframes fadeOut {
            0% {
                opacity: 1;
            }
            100% {
                opacity: 0;
            }
        }

        /* Themes */
        .resource-page--corporate &,
        .resource-page--strategy & {
            background-color: var(--joy-color-neutral-20);
        }
    }
</style>
